import { useState } from "react";

import type { DamagedCarImages } from "@/types/models/vehicle.types";

export function usePreviewPhotoModal() {
  const [open, setOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState<keyof DamagedCarImages | null>(null);
  const [zoomImage, setZoomImage] = useState<string | null>(null);

  const handleImagePreviewClick = (key: keyof DamagedCarImages) => {
    setSelectedKey(key);
  };

  const handleImageZoom = (imageSrc: string) => {
    setZoomImage(imageSrc);
  };

  const handleCloseZoom = () => {
    setZoomImage(null);
  };

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedKey(null);
  };

  return {
    open,
    selectedKey,
    zoomImage,
    handleImagePreviewClick,
    handleImageZoom,
    handleCloseZoom,
    handleOpenModal,
    handleCloseModal,
  };
}
